<template>
  <v-card class="rounded-custom">
    <v-toolbar flat color="primary" dark>
      <SvgIcon icon="cp-map-marker" height="25px" fill="white"></SvgIcon>
      <v-toolbar-title class="font-weight-bold pl-2">{{
        (event || {}).zone || "s/descripción"
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <SvgIcon icon="cp-event-date" height="25px" fill="white"></SvgIcon>
      <v-toolbar-title class="font-weight-bold body-2 pl-2">{{
        event.eventDateLegible
      }}</v-toolbar-title>
    </v-toolbar>
    <EventListItemSwiper
      :attachement-list="event.attachementList"
      :id-event="event.id"
    ></EventListItemSwiper>
    <v-divider></v-divider>
    <v-card-text class="pa-2 card-custom-background">
      <EventDetailBlock :event="event"></EventDetailBlock>
    </v-card-text>
    <v-card-actions class="card-custom-background pb-6">
      <v-spacer></v-spacer>
      <v-btn
        :to="'/costa-pez/buceos/' + event.id"
        color="#009c5e"
        width="150"
        large
        rounded
        dark
        >Ver más</v-btn
      >
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import EventListItemSwiper from "./EventListItemSwiper";
import EventDetailBlock from "./EventDetailBlock";
import SvgIcon from "@/components/SvgIcon";
export default {
  props: ["event"],
  components: { EventListItemSwiper, EventDetailBlock, SvgIcon }
};
</script>

<style></style>
